import firebase from 'firebase'
require('firebase/firestore')

const FIREBASE_API_KEY = process.env.REACT_APP_FIREBASE_API_KEY

const config = {
  apiKey: FIREBASE_API_KEY,
  authDomain: 'grace-card.firebaseapp.com',
  databaseURL: 'https://grace-card.firebaseio.com',
  projectId: 'grace-card',
  storageBucket: 'grace-card.appspot.com',
  messagingSenderId: '342980513225',
}

firebase.initializeApp(config)

export const db = firebase.firestore()



// WEBPACK FOOTER //
// ./src/firebase.js